import FormContactComponent from './FormContactComponent'

export default FormContactComponent
